import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import ExternalLink from './ExternalLink';
import styles from './AppsDownload.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {boolean=} props.whiteIcons
 * */
function AppsDownload({ className = '', whiteIcons = false }) {
  return (
    <ul className={`${styles.appsDownload} ${className}`}>
      <li>
        <ExternalLink href="https://itunes.apple.com/us/app/farmers-fridge/id1182307485?mt=8">
          {whiteIcons ? (
            <StaticImage
              src="../assets/img/itunesDownloadWhite.png"
              alt="Download the Farmer's Fridge App on iTunes"
              height={40}
              loading="lazy"
            />
          ) : (
            <StaticImage
              src="../assets/img/itunesDownload.png"
              alt="Download the Farmer's Fridge App on iTunes"
              height={40}
              loading="lazy"
            />
          )}
        </ExternalLink>
      </li>
      <li>
        <ExternalLink href="https://play.google.com/store/apps/details?id=com.farmersfridge.app&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
          {whiteIcons ? (
            <StaticImage
              src="../assets/img/googlePlayDownloadWhite.png"
              alt="Download the Farmer's Fridge App on Google Play"
              height={40}
              loading="lazy"
            />
          ) : (
            <StaticImage
              src="../assets/img/googlePlayDownload.png"
              alt="Download the Farmer's Fridge App on Google Play"
              height={40}
              loading="lazy"
            />
          )}
        </ExternalLink>
      </li>
    </ul>
  );
}

export default AppsDownload;
